import { useParams } from "react-router-dom";
import Members from "../members/Members";

export default function ClassroomStudents() {
  const params = useParams();

  return (
    <div>
      <Members showImport classroomIds={[params.classroomId as string]}></Members>
    </div>
  );
}
